import { render, staticRenderFns } from "./PaymentShipmentV2.vue?vue&type=template&id=7b10bb4c"
import script from "./PaymentShipmentV2.vue?vue&type=script&lang=js"
export * from "./PaymentShipmentV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports